import React, { FC } from 'react';
import { Hyperlink } from '../../components/Hyperlink';
import { isUrlInternal } from '../../utils/url-utils/urlUtils';
import { CommentaryLinkContent } from './CommentaryLinkContent';
import { WebCommentary } from '../commentary.types';

type Props = {
  commentary: WebCommentary;
  onCommentaryClicked: Function;
  source: string;
  className?: string;
  small?: boolean;
};

export const OpenCommentaryCard: FC<Props> = ({
  commentary,
  source,
  className,
  onCommentaryClicked,
  small = false,
}) => {
  const isDoctrineLink = isUrlInternal(commentary.url);

  return (
    <Hyperlink
      onClick={() => onCommentaryClicked(commentary)}
      href={commentary.url}
      source={isDoctrineLink ? source : ''}
      target={isDoctrineLink ? '' : '_blank'}
      rel={isDoctrineLink ? '' : 'nofollow'}
      className={className}
    >
      <CommentaryLinkContent
        commentary={commentary}
        isDoctrineLink={isDoctrineLink}
        small={small}
      />
    </Hyperlink>
  );
};
